module.exports = __webpack_public_path__ + "static/img/2.b5c23f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/2.png
// module id = 43wu
// module chunks = 0